<ng-template #content_country_configuration let-offcanvas>
  <div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.country_popup && wrapper">
    <div class="side_popup_header">
      <span>{{localService.languageContent.country_popup.header}}</span>
      <button class="button_icon" (click)="onCloseTrigger()">close</button>
    </div>
    <div class="side_popup_body" [ngStyle]="{'max-height' : localService.sideBarBodyHeight + 'px'}">
      <div class="side_popup_body_row_group">
        <div class="side_popup_body_row">
          <app-language-container [(languageContents)]="wrapper.languageContents"
            (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event)" [IsShowAllLanguages]="true"
            [IsAllMandatory]="true" [isModeChangeAllowed]="false"></app-language-container>
        </div>
        <div class="side_popup_body_row">
          <ngx-select [items]="localService.countryLocationLevels" [optionValueField]="'key'"
            [optionTextField]="'value'" [(ngModel)]="wrapper.content.v8" [noAutoComplete]="true">
          </ngx-select>
        </div>
        <div class="side_popup_body_row">
          <ngx-select [items]="localService.countryLocationLevels" [optionValueField]="'key'"
            [optionTextField]="'value'" [(ngModel)]="wrapper.content.v9" [noAutoComplete]="true">
          </ngx-select>
        </div>
        <div class="side_popup_body_row">
          <ngx-select [items]="localService.countryLocationLevels" [optionValueField]="'key'"
            [optionTextField]="'value'" [(ngModel)]="wrapper.content.v10" [noAutoComplete]="true">
          </ngx-select>
        </div>
      </div>
      <div class="side_popup_body_row_group">
        <div class="side_popup_body_row">
          <label class="lbl-secondary">{{localService.languageContent.country_popup.ctry_code}}</label>
          <input autocomplete="off" type="text" maxlength="3" [ngClass]="wrapper.content.v1 != '' ? 'en' : ''"
            [(ngModel)]="wrapper.content.v1" title="{{localService.languageContent.country_popup.ctry_code}}"
            placeholder="{{localService.languageContent.country_popup.ctry_code}}" />
        </div>
        <div class="side_popup_body_row">
          <label class="lbl-secondary">{{localService.languageContent.country_popup.regex}}</label>
          <input autocomplete="off" type="text" [ngClass]="wrapper.content.v4 != '' ? 'en' : ''"
            [(ngModel)]="wrapper.content.v4" title="{{localService.languageContent.country_popup.regex}}"
            placeholder="{{localService.languageContent.country_popup.regex}}" />
        </div>
        <div class="side_popup_body_row">
          <label class="lbl-secondary">{{localService.languageContent.country_popup.db}}</label>
          <input autocomplete="off" type="text" [ngClass]="wrapper.content.v5 != '' ? 'en' : ''"
            [(ngModel)]="wrapper.content.v5" title="{{localService.languageContent.country_popup.db}}"
            placeholder="{{localService.languageContent.country_popup.db}}" />
        </div>
        <div class="side_popup_body_row">
          <label class="lbl-secondary">{{localService.languageContent.country_popup.num_of_digits}}</label>
          <input autocomplete="off" type="number" class="number en" (keypress)="localService.isNumberOnly($event)"
            [(ngModel)]="wrapper.content.v2" />
        </div>
        <div class="side_popup_body_row">
          <label class="lbl-secondary">{{localService.languageContent.country_popup.contact_code}}</label>
          <input autocomplete="off" type="number" class="number en" (keypress)="localService.isNumberOnly($event)"
            [(ngModel)]="wrapper.content.v3" />
        </div>
        <div class="side_popup_body_row">
          <label class="lbl-secondary">{{localService.languageContent.country_popup.currency}}</label>
          <input autocomplete="off" type="text" [(ngModel)]="wrapper.content.v6" />
        </div>
        <div class="side_popup_body_row">
          <label style="font-weight: normal; margin-left: 15px;">
            <input type="checkbox" [(ngModel)]="isAlphaNumericPostalCode" />
            <span class="normal_color">{{localService.languageContent.country_popup.is_alpha_num_allowed}}</span>
          </label>
        </div>
        <div class="side_popup_body_row">
          <label class="lbl-secondary">{{localService.languageContent.country_popup.postal_digit}}</label>
          <input autocomplete="off" type="number" class="number en" (keypress)="localService.isNumberOnly($event)"
            [(ngModel)]="wrapper.content.v12" />
        </div>
        <div class="side_popup_body_row">
          <label class="lbl-secondary">{{localService.languageContent.country_popup.gmt}}</label>
          <app-mapping-container [items]="wrapper.timeZones" (onValuesUpdated)="onValuesUpdated($event,1)"
            [isOnlyNumbers]="true" [isDecimalAllowed]="true" [isNegativeAllowed]="true" [maximumDigits]="6"
            [MaxLines]="15" [Title]="localService.languageContent.country_popup.gmt"></app-mapping-container>
        </div>
      </div>
    </div>
    <div class="side_popup_footer">
      <button type="button" class="btn btn-primary"
        (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
    </div>
  </div>
</ng-template>